const formatDate = (date) => {
    let formattedDate = new Date(date)
    const day = formattedDate.toLocaleDateString('en-GB', { day: 'numeric' })

    formattedDate =
        day +
        ' ' +
        formattedDate.toLocaleDateString('en-GB', { month: 'short' }) +
        ' ' +
        formattedDate.toLocaleDateString('en-GB', { year: 'numeric' })

    return formattedDate
}

// prettier-ignore
const template = (data) => {
    return `<div class="grid__item"><a href="${data.url}" class="download">
            <div class="download__header">
                <svg width="18" height="18" class="download__icon">
                    <use xlink:href="/application/themes/rawnet/app/images/sprite.svg#download"></use>
                </svg>
                <div class="download__copy">
                    <h3 class="download__heading u-size-large">${data.name}</h3>
                    <p>Download</p>
                </div>
            </div>
            <div class="download__footer">
                <div>
                    <svg width="18" height="18" class="download__file">
                        <use xlink:href="/application/themes/rawnet/app/images/sprite.svg#file-${data.fileType}"></use>
                    </svg>
                    <span class="download__size u-ml0 u-color-midnight-opacity">${data.fileSize}</span>
                </div>
                ${data.membersOnly ? '<span class="tag tag--restricted download__tag">Members Only</span>' : ''}
            </div>
            <time datetime="${data.lastUpdated.date}" class="article__date">${formatDate(data.lastUpdated.date)}</time>
        </a>
    </div>`
}
export default template
